import { UPDATE_LOGO_SELECTOR_TAG, SKIP_AND_GO_TO_PURPOSE_PAGE } from '../mainActionTypes';

export default function tagSelectReducer(state = [], action) {
  const { type, payload } = action;
  let currentState = state;
  let currentTags = [];
  let newTags = [];
  switch (type) {
    case UPDATE_LOGO_SELECTOR_TAG:
      currentTags = state || [];
      newTags = toggleTag(currentTags, payload);
      currentState = [...newTags];
      break;
    case SKIP_AND_GO_TO_PURPOSE_PAGE:
      newTags = [];
      currentState = [...newTags];
      break;
    default:
      break;
  }
  return currentState;
}

function toggleTag(tags, tag) {
  const tagIndex = tags.indexOf(tag);
  tagIndex > -1 ? tags.splice(tagIndex, 1) : tags.push(tag);
  return tags;
}
